import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ObservationsService } from '../../services/observations.service';
import { Observation, ObservationType, ObservationTypeString } from '../../../domain-model/observation.class';
import { ActivatedRoute, Router } from '@angular/router';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { IObservationSummary } from '../../../message-models/observation-summary.interface';
import { ObservationModalService } from '../../services/observation-modal.service';
import { IObservation } from '../../../message-models/observation.interface';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { OurUserService } from '../../../users/services/user.service';
import { ExportExcelService } from 'src/app/common/services/export-excel.service';
import { DatePipe } from '@angular/common';
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';
import { EcaConfirmDeleteModalOptions } from '../../../shared/models/confirm-delete-modal-options.class';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { HelpConsts } from '../../../help/models/help-consts';
import { HelpModalService } from '../../../help/services/help-modal.service';
import { MenuItem } from 'primeng/api';
import { ObservationSummary } from '../../../domain-model/observation-summary';

@Component({
  selector: 'app-operatives-observations',
  templateUrl: './operatives-observations.component.html',
  styleUrls: ['./operatives-observations.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OperativesObservationsComponent implements OnInit {
  operativeObservations: Array<IObservationSummary> = new Array<IObservationSummary>();
  ObservationType: typeof ObservationType = ObservationType;
  ObservationTypeString: typeof ObservationTypeString = ObservationTypeString;
  selectedObservation: Observation = new Observation({} as IObservation);
  companyId = '';
  columns: any[];
  exportColumns: any[];
  observationRecordSummariesToExport: any[] = [];
  rowMenuItems: MenuItem[];

  constructor(private observationsService: ObservationsService,
    private route: ActivatedRoute,
    private router: Router,
    private observationModalService: ObservationModalService,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private confirmProcessService: EcaConfirmProcessService,
    private userService: OurUserService,
    private helpService: HelpModalService,
    private datePipe: DatePipe, private errorHandlingService: ErrorHandlingService,
    private exportExcelService: ExportExcelService) {
  }

  selectedOperativeId: string;
  selectedDocumentId: string;
  selectedTrainingRecordId: string;
  observationModalHeading: string;
  entityObservationId: string;
  operativeObservationLoading: boolean = true;
  loggedInUser: IUserInfo;
  isOnMobile = false;
  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;

    this.columns = [
      { field: 'operativeFirstName', header: 'Operative First Name', type: 'text' },
      { field: 'operativeLastName', header: 'Operative Last Name', type: 'text' },
      { field: 'observationTypeString', header: 'Type', type: 'text' },
      { field: 'observedBy', header: 'Observer', type: 'text' },
      { field: 'observedOn', header: 'Date Observed', type: 'date' },
      { field: 'followUpOn', header: 'Followup', type: 'date' },
      { field: 'summaryInfo', header: 'Information', type: 'text' },
      { field: 'notesAsHtml', header: 'Notes', type: 'html' },
    ];
    this.exportColumns =
      [
        { field: 'operativeFirstName', header: 'Operative First Name' },
        { field: 'operativeLastName', header: 'Operative Last Name' },
        { field: 'observationType', header: 'Type' },
        { field: 'observedBy', header: 'Observer' },
        { field: 'observedOn', header: 'Date Observed' },
        { field: 'followUpOn', header: 'Followup' },
        { field: 'summaryInfo', header: 'Information' },
        { field: 'notesAsHtml', header: 'Notes' },
      ];
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUser = user;
      this.companyId = this.loggedInUser.companyId;
      this.observationsService.getAllOperativeObservationsForCompany(this.companyId).subscribe(observationsSummaries => {
        observationsSummaries.forEach(x => {
          x.observationTypeString = ObservationTypeString[x.observationType];
        });
        this.operativeObservations = observationsSummaries;
        this.operativeObservationLoading = false;
        this.populateBreadcrumbs();
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
    // this.companyId = this.route.snapshot.params.companyId;

    this.rowMenuItems = [
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.deleteObservation($event)
      }
    ]

  }

  createObservation() {

  }

  //viewObservation(observationId: string, isEditing: boolean = false) {
  //  this.operativeObservations.forEach(opObservation => {
  //    if (opObservation.observationId === observationId) {
  //      this.observationModalHeading = 'Observation For ' + opObservation?.operativeName;
  //      this.selectedOperativeId = opObservation.operativeId;
  //      this.selectedObservation.id = observationId;
  //      this.selectedObservation.summaryInfo = opObservation.summaryInfo;
  //      this.selectedObservation.followUpOn = opObservation.followUpOn;
  //      this.selectedObservation.observationType = opObservation.observationType;
  //      this.selectedObservation.observedOn = opObservation.observedOn;
  //      this.selectedObservation.observedBy = opObservation.observedBy;
  //      this.selectedObservation.notesAsHtml = opObservation.notesAsHtml;
  //      switch (opObservation.observationType) {
  //        case ObservationType.Operative: {
  //          this.entityObservationId = opObservation.operativeObservationId;
  //          break;
  //        }
  //        case ObservationType.OperativeDocument:
  //        case ObservationType.TrainingRecordDocument: {
  //          this.entityObservationId = opObservation.documentObservationId;
  //          this.selectedDocumentId = opObservation.documentId;
  //          break;
  //        }
  //        case ObservationType.TrainingRecord: {
  //          this.entityObservationId = opObservation.trainingRecordObservationId;
  //          this.selectedTrainingRecordId = opObservation.trainingRecordId;
  //          break;
  //        }
  //      }
  //    }
  //  });

  //  this.observationModalService.createOrEditObservation(this.selectedObservation, this.observationModalHeading, false).subscribe(observationModalRef => {
  //    observationModalRef.content.saveObservationClicked.subscribe(observationResult => {
  //      if (observationResult !== null) {
  //        switch (observationResult.observationType) {
  //          case ObservationType.Operative: {
  //            this.operativeObservationLoading = true;
  //            this.observationsService.createOrUpdateOperativeObservation(observationResult, this.selectedOperativeId, this.companyId, this.entityObservationId).subscribe(operativeObservation => {
  //              this.operativeObservations = this.observationsService.updateObservationSummaries(this.operativeObservations, operativeObservation);
  //              this.operativeObservationLoading = false;
  //            }, () => {
  //              this.errorHandlingService.showErrorWarning().subscribe(() => {
  //              });
  //            });
  //            break;
  //          }
  //          case ObservationType.OperativeDocument:
  //          case ObservationType.TrainingRecordDocument: {
  //            this.operativeObservationLoading = true;
  //            this.observationsService.createOrUpdateDocumentObservation(observationResult, this.selectedDocumentId, this.companyId, this.entityObservationId).subscribe(documentObservation => {
  //              this.operativeObservations = this.observationsService.updateObservationSummaries(this.operativeObservations, documentObservation);
  //              this.operativeObservationLoading = false;
  //            }, () => {
  //              this.errorHandlingService.showErrorWarning().subscribe(() => {
  //              });
  //            });
  //            break;
  //          }
  //          case ObservationType.TrainingRecord: {
  //            this.operativeObservationLoading = true;
  //            this.observationsService.createOrUpdateTrainingRecordObservation(observationResult, this.selectedTrainingRecordId, this.companyId, this.entityObservationId).subscribe(trainingRecordObservation => {
  //              this.operativeObservations = this.observationsService.updateObservationSummaries(this.operativeObservations, trainingRecordObservation);
  //              this.operativeObservationLoading = false;
  //            }, () => {
  //              this.errorHandlingService.showErrorWarning().subscribe(() => {
  //              });
  //            });
  //            break;
  //          }
  //        }
  //        observationModalRef.dynamicDialogRef.close();
  //      }
  //    });
  //  });
  //}

  viewObservation(iObservationSummary?: IObservationSummary) {
    let observationSummary = new ObservationSummary(iObservationSummary);
    this.router.navigate(["/observation-details/" + observationSummary.observationId])

  }

  deleteObservation(observation: IObservationSummary) {
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to delete this observation?',
      'Delete ', new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.operativeObservationLoading = true;
            this.observationsService.deleteObservation(observation.observationId, observation.observationType, this.companyId).subscribe(result => {
              if (result) {
                this.operativeObservations.forEach(x => {
                  if (x.observationId === observation.observationId) {
                    this.operativeObservations = this.operativeObservations.filter(d => d.observationId !== observation.observationId);
                  }
                });
                this.operativeObservationLoading = false;
              }
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
              });
            });
          }
        }
      });
    // this.observationsService.deleteObservation(observation.observationId,observation.observationType );
  }

  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    operativeBreadCrumbs.push({ label: 'Operatives', iconName: 'users', routeLink: '/operatives' } as IBreadcrumb);
    operativeBreadCrumbs.push({ label: 'Observations', iconName: 'eye' } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  exportToExcel() {
    this.observationRecordSummariesToExport = [];
    this.operativeObservations.forEach(element => {
      let temporalDivElement = document.createElement('div');
      temporalDivElement.innerHTML = element.notesAsHtml;
      const tempObject = {
        operativeFirstName: element.operativeFirstName,
        operativeLastName: element.operativeLastName,
        observationType: ObservationType[element.observationType],
        observedBy: element.observedBy,
        observedOn: this.datePipe.transform(element.observedOn?.dateTime, 'dd/MM/yyyy'),
        followUpOn: this.datePipe.transform(element.followUpOn?.dateTime, 'dd/MM/yyyy'),
        summaryInfo: element.summaryInfo,
        notesAsHtml: temporalDivElement.textContent || temporalDivElement.innerText || ''
      };
      this.observationRecordSummariesToExport.push(tempObject);
    });

    this.exportExcelService.exportToExcel(this.observationRecordSummariesToExport, this.exportColumns, 'All Operative Observations');

  }

  openOperativesObservationsHelp() {
    this.helpService.openHelpModal(HelpConsts.AllOperativeObservationsHelp);
  }
}
